module.exports = __webpack_public_path__ + "img/mobile scanner stand07.ef5ee87b.jpg";